var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chartist',{attrs:{"type":"Bar","data":_vm.chartData,"options":_vm.chartOptions,"event-handlers":_vm.events}})}
var staticRenderFns = []

export { render, staticRenderFns }